import React, { useMemo, useContext } from 'react';
import { Translator } from 'ggApp/modules/translator';
import { formatPriceByLanguage } from 'ggApp/utils/money';
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';
import If from 'ggApp/shared/components/Conditional';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import {
    CartPreviewWrap,
    CartPreviewTitle,
    ThumbnailsWrap,
    ProductThumbnail,
    CartPreviewText,
    Text,
    Price,
    QtyBadge,
    QtyText,
    ProductThumbWrapper,
} from './styles';

const ProductsInCart = ({ className }) => {
    const { cart, activeStore } = useContext(OrderContext);

    const productThumbnails = useMemo(() => {
        if (cart.items) {
            const display = cart.items.length <= 3 ? cart.items : cart.items.slice(0, 2);

            return display.map((item) => {
                return { image: item.imageUrl, quantity: item.quantity };
            });
        }

        return null;
    }, [cart]);

    const counterThumbnail = useMemo(() => {
        const orderQuantity = (cart?.items ?? []).reduce((total, item) => total + item.quantity, 0);

        if (cart.items) {
            if (cart.items.length <= 3) {
                return '';
            }

            const shownItems = productThumbnails.reduce((total, item) => total + item.quantity, 0);
            const counter = orderQuantity - shownItems;

            return counter;
        }
        return null;
    }, [cart, productThumbnails]);

    const productText = useMemo(() => {
        if (cart.items) {
            if (cart.items.length === 1) {
                const productName = cart.items[0].name;
                return productName;
            }
            return <Translator tk="CART_PREVIEW_TEXT" />;
        }
        return null;
    }, [cart]);

    const orderPrice = useMemo(() => {
        if (cart.itemTotal) {
            const currency = CURRENCIES_ASSOCIATION[activeStore.default_currency];
            const formattedPrice = formatPriceByLanguage(
                cart.itemTotal,
                currency,
                activeStore.activeLanguage,
            );
            return formattedPrice;
        }

        return null;
    }, [activeStore, cart]);

    if (!cart.items) {
        return null;
    }
    return (
        <CartPreviewWrap className={className}>
            <CartPreviewTitle tk="CART_PREVIEW_TITLE" />

            <ThumbnailsWrap>
                {productThumbnails &&
                    productThumbnails.map((item) => (
                        <ProductThumbWrapper key={item.image}>
                            <ProductThumbnail productThumbnail={item.image} />
                            <If condition={item.quantity > 1}>
                                <QtyBadge>
                                    <QtyText tag="label">{item.quantity}</QtyText>
                                </QtyBadge>
                            </If>
                        </ProductThumbWrapper>
                    ))}

                {counterThumbnail && <ProductThumbnail>+{counterThumbnail}</ProductThumbnail>}

                <CartPreviewText>
                    <Text>{productText}</Text>
                    <Price>
                        <Translator
                            tk="CART_PREVIEW_PER_MONTH"
                            withValues={{ price: orderPrice }}
                        />
                    </Price>
                </CartPreviewText>
            </ThumbnailsWrap>
        </CartPreviewWrap>
    );
};

export default ProductsInCart;
